<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Entitlement Setting Detail"
      text="Edit Claim Entitlement Setting Detail"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="localClaimEntitlementSettingDetail.job_category_id"
                v-validate="'required'"
                :items="jobCategories"
                label="Job Category"
                :error-messages="errors.collect('jobCategory')"
                data-vv-name="jobCategory"   
                data-vv-as="job category"   
                item-text="name"
                item-value="id"
                disabled
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localClaimEntitlementSettingDetail.max_amount"
                v-validate="'required|validAmount'"
                v-money="money"
                :error-messages="errors.collect('maxAmount')"
                data-vv-as="amount"
                data-vv-name="maxAmount"
                label="Maximum Claim Amount"
                prefix="RM"
                :suffix="'/' + creditUnit"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    directives: { money: VMoney },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      claimEntitlementSettingDetail: {
        type: Object,
        required: true,
      },
      jobCategories: {
        type: Array,
        required: true,
      },
      creditUnit: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localClaimEntitlementSettingDetail: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    watch: {
      dialog: function (value) {
        if (value) this.localClaimEntitlementSettingDetail = { ...this.claimEntitlementSettingDetail }

        this.$validator.extend('validAmount', {
          getMessage (field, args) {
            return 'Amount should be more than 0'
          },
          validate (value, args) {
            return value.toString().replaceAll(',', '') > 0
          },
        })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.claimEntitlementSettingDetails().update(this.localClaimEntitlementSettingDetail.id, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: 'Claim Entitlement Setting Detail Updated Successfully' })

                  this.dialog = false
                }
              })
              .catch(err => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.message, 
                  })
                }

                if (err.response.status === 500) {
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })      
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          job_category_id: this.localClaimEntitlementSettingDetail.job_category_id,
          max_amount: this.localClaimEntitlementSettingDetail.max_amount,
        }
      },
    },
  }
</script>
